import { CurrentOrganizationLogoProps } from '../types'
import React from 'react'
import Stack from '@mui/material/Stack'

export const CurrentOrganizationLogo: React.FC<CurrentOrganizationLogoProps> = ({
    organization,
    isDarkMode,
    onClick,
}) => (
    <Stack className="logo-container" onClick={onClick}>
        <img
            src={isDarkMode ? organization.image : organization.lightModeImage}
            alt={`${organization.name} Logo`}
            className="orgLogo admin-logo"
        />
    </Stack>
)
